import React from 'react';
import { Legend, Line, LineChart, Tooltip, XAxis, YAxis } from 'recharts';

const colors = ['#003a7d', '#008dff', '#ff73b6', '#c701ff', '#4ecb8d', '#ff9d3a', '#f9e858', '#d83034'];

function NestedTimeSeriesChart({ data, headings, config }) {
  const validKeys = ['date'];
  const validLabels = ['Date'];
  headings.forEach(head => {
    if (head._total) {
      validKeys.push(head._data_label);
      validLabels.push(head[config.headings_hierarchy[0]] + ': total');
    }
  });
  const labeledData = [];
  data.forEach(row => {
    const newRow = {};
    validKeys.forEach((key, index) => {
      newRow[validLabels[index]] = row[key];
    });
    labeledData.push(newRow);
  });
  return (
    <div>
      <LineChart width={800} height={400} data={labeledData}>
        <XAxis dataKey={validLabels[0]} />
        <YAxis />
        <Tooltip />
        <Legend />
        {validLabels.slice(1).map((validLabel, index) => (
          <Line type="monotone" key={validLabel} dataKey={validLabel} stroke={colors[index]} />
        ))}
      </LineChart>
    </div>
  );
}

function TimeSeriesChart({ data, headings, config }) {
  if (config.nested) {
    return (<NestedTimeSeriesChart data={data} headings={headings} config={config} />);
  }
  return (
    <div>
      <LineChart width={800} height={400} data={data}>
        <XAxis dataKey={headings[0]} />
        <YAxis dataKey={headings[1]} />
        <Tooltip />
        <Legend />
        {headings.slice(1).map((heading, index) => (
          <Line type="monotone" dataKey={heading} stroke={colors[index]} />
        ))}
      </LineChart>
    </div>
  );
}

export default TimeSeriesChart;